var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6316 29.3543V10.0787H20.2105V29.3543L16.4211 25.8268L12.6316 29.3543ZM25.2632 33.1339V0H32.8421V25.5748L25.2632 33.1339ZM0 41.8268V20.1575H7.57895V34.2677L0 41.8268ZM0 48L16.2947 31.748L25.2632 39.4331L39.4105 25.3228H35.3684V20.2835H48V32.8819H42.9474V28.8504L25.5158 46.2362L16.5474 38.5512L7.07368 48H0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceMode);
export default __webpack_public_path__ + "static/media/finance_mode.a34b88bf2d0277be771fc071dce644ec.svg";
export { ForwardRef as ReactComponent };